<template>
  <div class="product-card">
    <div class="product-card__img" @click.stop="onCardAction">
      <img
        v-if="item.photo"
        :src="item.photo"
        :alt="item.title"
        @error="onImgError"
      />
      <div v-else class="product-card__placeholder">
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
            fill="#444"
          />
        </svg>
      </div>
      <span class="product-card__price">{{ item.price.toFixed(2) }}€</span>
    </div>
    <div class="product-card__info">
      <h6 class="product-card__title">{{ item.title }}</h6>
      <p v-if="item.description" class="product-card__desc">
        {{ item.description }}
      </p>
      <div class="product-card__btn" @click.stop="onCardAction">
        <span>Hinzufügen</span>
      </div>
    </div>
  </div>
</template>

<script>
import foodPlaceholder from "@/assets/images/food-placeholder.svg";

export default {
  props: {
    item: { type: Object, required: true },
    index: { type: Number, required: true },
    cartItems: { type: Array, required: true },
  },
  data() {
    return { foodPlaceholder };
  },
  computed: {
    hasIngredients() {
      return (
        this.item.sauces.length > 0 ||
        this.item.meats.length > 0 ||
        this.item.salads.length > 0 ||
        this.item.extras.length > 0 ||
        this.item.pomm_rice.length > 0 ||
        this.item.drinks.length > 0
      );
    },
  },
  methods: {
    onCardAction() {
      if (this.hasIngredients) {
        this.$root.$emit("openProductDrawer", this.item);
        return;
      }
      this.addDirectlyToCart();
    },
    onImgError(e) {
      e.target.style.display = "none";
    },
    addDirectlyToCart() {
      const existing = this.cartItems.find(
        (cartItem) => cartItem._id === this.item._id
      );
      if (existing) {
        this.$store.commit("shop/UPDATE_ITEM_QUANTITY", {
          cartItemID: existing.cartItemID,
          newValue: existing.quantity + 1,
        });
      } else {
        this.$store.dispatch("shop/additemInCart", { ...this.item });
      }
      this.$emit("onShowCartButtonOnMobile");
    },
  },
};
</script>

<style lang="scss" scoped>
.product-card {
  background: var(--pok-card);
  border-radius: 20px;
  border: 0.5px solid var(--pok-border);
  overflow: hidden;
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }

  &__img {
    position: relative;
    width: 100%;
    aspect-ratio: 1.4;
    background: var(--pok-card-light);
    overflow: hidden;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, var(--pok-card-light), var(--pok-card));
  }

  &__price {
    position: absolute;
    bottom: 8px;
    right: 8px;
    background: #c41e2a;
    color: #fff;
    padding: 4px 10px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 800;
    box-shadow: 0 2px 8px rgba(196, 30, 42, 0.4);
  }

  &__info {
    padding: 10px 12px 12px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  &__title {
    font-size: 13px;
    font-weight: 700;
    color: var(--pok-text);
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.3;
    height: 34px;
  }

  &__desc {
    font-size: 11px;
    color: var(--pok-text-muted);
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 29px;
    flex-shrink: 0;
    margin-bottom: 12px;
  }

  &__btn {
    display: inline-flex;
    align-items: center;
    background: #fff;
    color: #121212;
    padding: 7px 14px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    margin-top: auto;

    &:hover {
      opacity: 0.85;
    }
  }
}
</style>
